<template lang="pug">
.v-awards-page.awards-page(v-if="data")
	.awards-page__head.page-head(v-if="data.title")
		component.page-head__title(
			:is="data.titleLevel ? data.titleLevel : 'h1'"
			:class="data.titleStyleLevel")
			| {{data.title}}
	.awards-page__body(v-if="data.items" )
		.awards-page__block.flc(v-for="(item, index) in data.items" :key="index" )
			.awards-page__date.tag
				.tag__text(v-if="item.title" ) {{ item.title }}
			.awards-page__cards(v-if="item.items" )
				.awards-page__card(
						v-for="(card, index) in item.items"
						:key="index")
					.awards-page__card-inner
						.awards-page__card-background(:style="{background: `center / cover no-repeat url(${card?.image?.src ? card.image.src : '#0E0E0F'})`}")
						.awards-page__card-blackout
						img.awards-page__card-image(
							v-if="card.image"
							:src="card.image?.src"
							:alt="card.image?.alt"
							@click="openFullImg(card.image)")
						.awards-page__card-text(v-if="card.text" ) {{ card.text }}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import controller from "../scripts/controller/controller.js";

export default {

	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		},

		openFullImg(cardImage) {
			controller.openModal({
				className: 'modal-awards',
				content: `<v-modal-window>
							<img src="${cardImage.src}" alt="${cardImage.alt}">
						</v-modal-window>`
			})
		}
	}
}

</script>